import type { ReactNode } from 'react'
import { RoleGate } from '../../shared/auth/RoleGate'

/**
 * Admin route gate — a thin alias over the generalized {@link RoleGate}.
 * Kept as a named export so `administration/routes.ts` (which registers it as
 * a pathless route `component`) is unchanged.
 */
export function AdminGate({ children }: { children?: ReactNode }) {
  return <RoleGate requiredRole="Admin">{children}</RoleGate>
}
